<template>
    <v-row no-gutters class="mb-6">
        <v-col cols="12">
            <v-card class="team-section-card pa-4 pa-md-6">
                <div class="team-section-header">
                    <span class="team-section-kicker">Ομάδα</span>
                    <h1 class="team-section-title">Παίκτες και επιτελείο</h1>
                </div>

                <div class="team-group-block">
                    <h2 class="team-group-title">Παίκτες</h2>
                    <v-row>
                        <v-col v-for="member in playerMembers" :key="`player-${member.id || member.number || member.name}`" cols="12" sm="6" lg="4">
                            <v-card outlined class="team-info-card fill-height">
                                <v-card-title class="team-card-title">#{{ member.number }} {{ member.name }}</v-card-title>
                                <v-card-text>
                                    <v-row align="center" no-gutters>
                                        <v-col cols="6" class="player-text-col" align="start">
                                            <div class="team-person-role">{{ member.position }}</div>
                                            <div class="team-person-meta">{{ member.height }}</div>
                                            <div class="team-person-meta">{{ member.nationality }}</div>
                                            <div v-if="formatBirthDate(member.birthDate)" class="team-person-meta">{{ formatBirthDate(member.birthDate) }}</div>
                                        </v-col>
                                        <v-col cols="6" class="player-image-col">
                                            <img :src="getMemberImage(member)" :alt="member.name" class="player-image">
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col v-if="!playerMembers.length" cols="12">
                            <div class="team-empty-text">Δεν υπάρχουν διαθέσιμοι παίκτες.</div>
                        </v-col>
                    </v-row>
                </div>

                <div class="team-group-block">
                    <h2 class="team-group-title">Επιτελείο</h2>
                    <v-row>
                        <v-col v-for="member in staffMembers" :key="`staff-${member.id || member.name}`" cols="12" sm="6" md="4" lg="3">
                            <v-card outlined class="team-info-card fill-height">
                                <v-card-title class="team-card-title">{{ member.name }}</v-card-title>
                                <v-card-text>
                                    <v-row align="center" no-gutters>
                                        <v-col cols="6" class="player-text-col" align="start">
                                            <div class="team-person-role">{{ member.position || '-' }}</div>
                                            <div v-if="member.nationality && member.nationality !== '-'" class="team-person-meta">{{ member.nationality }}</div>
                                            <div v-if="formatBirthDate(member.birthDate)" class="team-person-meta">{{ formatBirthDate(member.birthDate) }}</div>
                                        </v-col>
                                        <v-col cols="6" class="player-image-col">
                                            <img :src="getMemberImage(member)" :alt="member.name" class="player-image">
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col v-if="!staffMembers.length" cols="12">
                            <div class="team-empty-text">Δεν υπάρχουν στοιχεία staff.</div>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: 'TeamRosterSection',
        props: {
            members: {
                type: Array,
                default: () => []
            },
            defaultPlayerImage: {
                type: String,
                default: ''
            },
            memberImageResolver: {
                type: Function,
                default: () => ''
            }
        },
        computed: {
            staffMembers() {
                return this.members.filter(member => this.isStaff(member))
            },
            playerMembers() {
                return this.members.filter(member => !this.isStaff(member))
            }
        },
        methods: {
            isStaff(member) {
                const role = String(member && member.role ? member.role : '').trim().toLowerCase()
                return role === 'staff' || role.includes('coach') || role.includes('προπονητ')
            },
            formatBirthDate(value) {
                if (!value) {
                    return ''
                }

                const date = new Date(value)
                if (Number.isNaN(date.getTime())) {
                    return ''
                }

                const day = String(date.getDate()).padStart(2, '0')
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const year = date.getFullYear()

                return `${day}/${month}/${year}`
            },
            getMemberImage(member) {
                return this.memberImageResolver(member) || this.defaultPlayerImage
            }
        }
    }
</script>

<style scoped>
.team-section-card {
    background: rgba(255, 255, 255, 0.96);
}

.team-section-header {
    margin-bottom: 20px;
    text-align: left;
}

.team-section-kicker {
    display: inline-block;
    margin-bottom: 6px;
    color: #ac2f37;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.team-section-title {
    margin: 0;
    color: #223152;
    font-size: clamp(1.5rem, 2.4vw, 2.2rem);
    line-height: 1.15;
    text-transform: none !important;
}

.team-group-block + .team-group-block {
    margin-top: 20px;
}

.team-group-title {
    margin: 0 0 12px;
    text-align: left;
    color: #223152;
    font-size: 1.15rem;
    font-weight: 700;
    text-transform: none !important;
}

.team-card-title {
    word-break: break-word;
    color: #223152;
    font-weight: 700;
}

.team-person-name {
    color: #223152;
    font-size: 1.15rem;
    font-weight: 700;
}

.team-person-role {
    color: #ac2f37;
    font-weight: 600;
    margin-bottom: 8px;
}

.player-text-col {
    padding-right: 12px;
}

.player-image-col {
    display: flex;
    align-items: center;
    justify-content: center;
}

.player-image {
    width: 100%;
    max-width: 120px;
    height: auto;
    object-fit: contain;
}

.team-person-meta {
    color: #4b5970;
}

.team-empty-text {
    text-align: left;
    color: #5b677b;
    font-weight: 600;
}
</style>
